import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef } from "react";
import "./pncNew.css";
import AboutModal from "./Modals/AboutModal";
import FeedbackModal from "./Modals/FeedbackModal";
import DeleteConfirmationModal from "./Modals/DeleteConfirmationModal";
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import Main from "./Main/Main";
import { CHAT_API_ENDPOINTS } from "../api/CHAT_API_ENDPOINTS.js";
import usFlag from "../assets/united-states.png";
import jpFlag from "../assets/japan.png";

const PncNew = () => {
  const { t, i18n } = useTranslation();

  const [isChatStarted, setIsChatStarted] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [searchInput, setSearchInput] = useState({
    vin: "",
    model: "",
    classification: "",
  });
  const [chatId, setChatId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [subGroups, setSubGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");

  const [selectedGroupMainGroup, setSelectedGroupMainGroup] = useState("");
  const [selectedSubGroupMainGroup, setSelectedSubGroupMainGroup] =
    useState("");

  const [selectedSubGroup, setSelectedSubGroup] = useState("");
  const [isLoadingSubGroups, setIsLoadingSubGroups] = useState(false);
  const [vinError, setVinError] = useState("");
  const [isValidVin, setIsValidVin] = useState(false);

  const [isLoadingVin, setIsLoadingVin] = useState(false);
  const [vinResults, setVinResults] = useState(null);
  const [adjustedLineOffDate, setAdjustedLineOffDate] = useState("");
  const [catalogNo, setCatalogNo] = useState("");
  const [model, setModel] = useState("");
  const [classification, setClassification] = useState("");
  const [opt, setOpt] = useState("");
  const [vinInput, setVinInput] = useState("");
  const vinTimeoutRef = useRef(null);
  const [modelInput, setModelInput] = useState("");
  const [classificationInput, setClassificationInput] = useState("");
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [modelClassError, setModelClassError] = useState("");
  const [isValidModelClass, setIsValidModelClass] = useState(false);
  const [isLoadingModelClass, setIsLoadingModelClass] = useState(false);

  const [showMainGroupDropdown, setShowMainGroupDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [groupDropdownOpen, setGroupDropdownOpen] = useState(false);
  const [subGroupDropdownOpen, setSubGroupDropdownOpen] = useState(false);

  // New state variables for user messages
  const [userInput, setUserInput] = useState("");
  const [userMessages, setUserMessages] = useState([]);
  const [showUserPart, setShowUserPart] = useState(false);

  const [assistantMessages, setAssistantMessages] = useState([]);
  const [isThinking, setIsThinking] = useState(false);
  const [dots, setDots] = useState("");
  const [hideInitialMessages, setHideInitialMessages] = useState(false);
  const [showSearchParams, setShowSearchParams] = useState(false);
  const [askAnotherQueryClicked, setAskAnotherQueryClicked] = useState(false);
  const [showYesSelection, setShowYesSelection] = useState(false);

  const [conversationCycleId, setConversationCycleId] = useState(
    () => `cycle-${Date.now()}`
  );
  const [conversationHistory, setConversationHistory] = useState({});
  const [cycleId, setCycleId] = useState(0);
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState("");
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  // Add new state variables for chat history
  const [chatHistory, setChatHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [historyError, setHistoryError] = useState("");

  const [selectedHistoryId, setSelectedHistoryId] = useState(null);
  const chatContainerRef = useRef(null);
  const messagesEndRef = useRef(null);

  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

  // Add new state for managing the three-dots menu
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [pinnedChats, setPinnedChats] = useState([]);
  const dropdownRef = useRef(null);

  const [selectedLanguage, setSelectedLanguage] = useState("jp");

  //Prompt Suggestions
  const [selectedPromptIndex, setSelectedPromptIndex] = useState(0);
  const [promptSuggestions, setPromptSuggestions] = useState([]);
  const [chassis1Suggestions, setChassis1Suggestions] = useState([]);
  const [chassis2Suggestions, setChassis2Suggestions] = useState([]);
  const [isLoadingChassis1Suggestions, setIsLoadingChassis1Suggestions] =
    useState(false);
  const [isLoadingChassis2Suggestions, setIsLoadingChassis2Suggestions] =
    useState(false);
  const [showChassis1Dropdown, setShowChassis1Dropdown] = useState(false);
  const [showChassis2Dropdown, setShowChassis2Dropdown] = useState(false);
  const chassis1SuggestionsTimeoutRef = useRef(null);
  const chassis2SuggestionsTimeoutRef = useRef(null);
  const chassis1DropdownRef = useRef(null);
  const chassis2DropdownRef = useRef(null);
  const [hasChassis1SuggestionsResponse, setHasChassis1SuggestionsResponse] =
    useState(false);
  const [hasChassis2SuggestionsResponse, setHasChassis2SuggestionsResponse] =
    useState(false);
  const [modelSuggestions, setModelSuggestions] = useState([]);
  const [classificationSuggestions, setClassificationSuggestions] = useState([]);
  const [isLoadingModelSuggestions, setIsLoadingModelSuggestions] = useState(false);
  const [isLoadingClassificationSuggestions, setIsLoadingClassificationSuggestions] = useState(false);
  const [showModelDropdown, setShowModelDropdown] = useState(false);
  const [showClassificationDropdown, setShowClassificationDropdown] = useState(false);
  const modelSuggestionsTimeoutRef = useRef(null);
  const classificationSuggestionsTimeoutRef = useRef(null);
  const modelDropdownRef = useRef(null);
  const classificationDropdownRef = useRef(null);
  const [hasModelSuggestionsResponse, setHasModelSuggestionsResponse] = useState(false);
  const [hasClassificationSuggestionsResponse, setHasClassificationSuggestionsResponse] = useState(false);

  useEffect(() => {
    setPromptSuggestions([
      t("whatPartNumbers"),
      t("portalDescription"),
      t("partNumberQuantity"),
      // t('vinModelDetails'), // if you want to uncomment this later
    ]);
  }, [t, selectedLanguage]);

  const [showPromptSuggestion, setShowPromptSuggestion] = useState(false);
  const [selectedPromptSuggestion, setSelectedPromptSuggestion] = useState("");
  const [showQueriesInChat, setShowQueriesInChat] = useState(false);

  const [isQueriesDropdownOpen, setIsQueriesDropdownOpen] = useState(false);
  const queriesDropdownRef = useRef(null);
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isLogoutDropdownOpen, setIsLogoutDropdownOpen] = useState(false);
  const logoutDropdownRef = useRef(null);

  const [isListening, setIsListening] = useState(false);
  const [speechRecognition, setSpeechRecognition] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteItemInfo, setDeleteItemInfo] = useState(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const languageMenuRef = useRef(null);

  const [zone, setZone] = useState("");

  const [vinSuggestions, setVinSuggestions] = useState([]);
  const [isLoadingVinSuggestions, setIsLoadingVinSuggestions] = useState(false);
  const [showVinDropdown, setShowVinDropdown] = useState(false);
  const vinSuggestionsTimeoutRef = useRef(null);
  const vinDropdownRef = useRef(null);
  const [hasVinSuggestionsResponse, setHasVinSuggestionsResponse] =
    useState(false);
  const [chassis1Input, setChassis1Input] = useState("");
  const [chassis2Input, setChassis2Input] = useState("");
  const [isLoadingChassis, setIsLoadingChassis] = useState(false);
  const [chassisError, setChassisError] = useState("");
  const [chassisResults, setChassisResults] = useState(null);
  const [chassis2LengthError, setChassis2LengthError] = useState(false);

  // Store data for both languages
  const [dataByLanguage, setDataByLanguage] = useState({
    en: { groups: [], subGroups: [], vinResults: null, chassisResults: null, modelClassResults: null },
    jp: { groups: [], subGroups: [], vinResults: null, chassisResults: null, modelClassResults: null }
  });

  // Store the selected sub group index to map between languages
  const [selectedSubGroupIndex, setSelectedSubGroupIndex] = useState(-1);
  // Store the selected group index to map between languages
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(-1);

  // Language options
  const languageOptions = [
    { code: "en", name: "English", flag: usFlag, speechCode: "en-US" },
    // { code: "hi-IN", name: "हिन्दी", flag: "🇮🇳", speechCode: "hi-IN" },
    { code: "jp", name: "Japanese", flag: jpFlag, speechCode: "ja-JP" }, // Fixed: use ja-JP for speech
  ];

  const fetchVinSuggestions = async (vinInput) => {

    if (!vinInput) {
      setVinSuggestions([]);
      setShowVinDropdown(false);
      setHasVinSuggestionsResponse(false);
      setVinResults(null); // Clear results
      return;
    }

    setIsLoadingVinSuggestions(true);

    try {
      const response = await fetch(
        `${CHAT_API_ENDPOINTS.GET_VIN_SUGGESTIONS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vin: vinInput.trim() }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch VIN suggestions");
      }

      const data = await response.json();

      let suggestions = [];
      if (data && Array.isArray(data.vin_list)) {
        suggestions = data.vin_list;
      } else {
        suggestions = [];
      }


      // Update state
      setVinSuggestions(suggestions);
      setShowVinDropdown(suggestions.length > 0);
      setHasVinSuggestionsResponse(true);

      // 🔥 CRITICAL: Clear vinResults when we get empty suggestions
      if (suggestions.length === 0) {
        setVinResults(null);
        setIsValidVin(false);
        setGroups([]);
        setSubGroups([]);
      }

    } catch (error) {
      setVinSuggestions([]);
      setShowVinDropdown(false);
      setHasVinSuggestionsResponse(true);
      setVinResults(null);
      setIsValidVin(false);
    } finally {
      setIsLoadingVinSuggestions(false);
    }
  };

  // Updated fetchChassis1Suggestions function
  const fetchChassis1Suggestions = async (chassisInput) => {

    if (!chassisInput) {
      setChassis1Suggestions([]);
      setShowChassis1Dropdown(false);
      setHasChassis1SuggestionsResponse(false);
      return;
    }

    setIsLoadingChassis1Suggestions(true);

    try {
      // Prepare payload with both chassis numbers
      const payload = { chassis_no_1: chassisInput.trim() };

      // Include chassis_no_2 if it exists
      if (chassis2Input && chassis2Input.trim()) {
        payload.chassis_no_2 = chassis2Input.trim();
      }

      const response = await fetch(
        `${CHAT_API_ENDPOINTS.GET_VIN_SUGGESTIONS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch Chassis1 suggestions");
      }

      const data = await response.json();

      let suggestions = [];

      // Check for chassis_no_1_list in the response
      if (data && Array.isArray(data.chassis_no_1_list)) {
        suggestions = data.chassis_no_1_list;
      } else {
        suggestions = [];
      }

      setChassis1Suggestions(suggestions);
      setShowChassis1Dropdown(suggestions.length > 0);
      setHasChassis1SuggestionsResponse(true);
    } catch (error) {
      console.error("Error fetching Chassis1 suggestions:", error);
      setChassis1Suggestions([]);
      setShowChassis1Dropdown(false);
      setHasChassis1SuggestionsResponse(true);
    } finally {
      setIsLoadingChassis1Suggestions(false);
    }
  };


  // Updated fetchChassis2Suggestions function
  const fetchChassis2Suggestions = async (chassisInput) => {

    if (!chassisInput) {
      setChassis2Suggestions([]);
      setShowChassis2Dropdown(false);
      setHasChassis2SuggestionsResponse(false);
      return;
    }

    setIsLoadingChassis2Suggestions(true);

    try {
      // Prepare payload with both chassis numbers
      const payload = { chassis_no_2: chassisInput.trim() };

      // Include chassis_no_1 if it exists
      if (chassis1Input && chassis1Input.trim()) {
        payload.chassis_no_1 = chassis1Input.trim();
      }

      const response = await fetch(
        `${CHAT_API_ENDPOINTS.GET_VIN_SUGGESTIONS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch Chassis2 suggestions");
      }

      const data = await response.json();

      let suggestions = [];

      // Check for chassis_no_2_list in the response
      if (data && Array.isArray(data.chassis_no_2_list)) {
        suggestions = data.chassis_no_2_list;
      } else {
        suggestions = [];
      }

      setChassis2Suggestions(suggestions);
      setShowChassis2Dropdown(suggestions.length > 0);
      setHasChassis2SuggestionsResponse(true);
    } catch (error) {
      console.error("Error fetching Chassis2 suggestions:", error);
      setChassis2Suggestions([]);
      setShowChassis2Dropdown(false);
      setHasChassis2SuggestionsResponse(true);
    } finally {
      setIsLoadingChassis2Suggestions(false);
    }
  };

  // fetchModelSuggestions function
  const fetchModelSuggestions = async (modelInputValue) => {
    if (!modelInputValue) {
      setModelSuggestions([]);
      setShowModelDropdown(false);
      setHasModelSuggestionsResponse(false);
      return;
    }

    setIsLoadingModelSuggestions(true);

    try {
      const payload = { model: modelInputValue.trim() };

      // Include classification if it exists
      if (classificationInput && classificationInput.trim()) {
        payload.classification = classificationInput.trim();
      }

      const response = await fetch(
        `${CHAT_API_ENDPOINTS.GET_VIN_SUGGESTIONS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch Model suggestions");
      }

      const data = await response.json();

      let suggestions = [];

      // Check for model_list in the response
      if (data && Array.isArray(data.model_list)) {
        suggestions = data.model_list;
      } else {
        suggestions = [];
      }

      setModelSuggestions(suggestions);
      setShowModelDropdown(suggestions.length > 0);
      setHasModelSuggestionsResponse(true);
    } catch (error) {
      console.error("Error fetching Model suggestions:", error);
      setModelSuggestions([]);
      setShowModelDropdown(false);
      setHasModelSuggestionsResponse(true);
    } finally {
      setIsLoadingModelSuggestions(false);
    }
  };

  // fetchClassificationSuggestions function
  const fetchClassificationSuggestions = async (classificationInputValue) => {
    if (!classificationInputValue) {
      setClassificationSuggestions([]);
      setShowClassificationDropdown(false);
      setHasClassificationSuggestionsResponse(false);
      return;
    }

    setIsLoadingClassificationSuggestions(true);

    try {
      const payload = { classification: classificationInputValue.trim() };

      // Include model if it exists
      if (modelInput && modelInput.trim()) {
        payload.model = modelInput.trim();
      }

      const response = await fetch(
        `${CHAT_API_ENDPOINTS.GET_VIN_SUGGESTIONS}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch Classification suggestions");
      }

      const data = await response.json();

      let suggestions = [];

      // Check for classification_list in the response
      if (data && Array.isArray(data.classification_list)) {
        suggestions = data.classification_list;
      } else {
        suggestions = [];
      }

      setClassificationSuggestions(suggestions);
      setShowClassificationDropdown(suggestions.length > 0);
      setHasClassificationSuggestionsResponse(true);
    } catch (error) {
      console.error("Error fetching Classification suggestions:", error);
      setClassificationSuggestions([]);
      setShowClassificationDropdown(false);
      setHasClassificationSuggestionsResponse(true);
    } finally {
      setIsLoadingClassificationSuggestions(false);
    }
  };


  useEffect(() => {
    function handleClickOutside(event) {
      if (
        chassis1DropdownRef.current &&
        !chassis1DropdownRef.current.contains(event.target)
      ) {
        setShowChassis1Dropdown(false);
      }
      if (
        chassis2DropdownRef.current &&
        !chassis2DropdownRef.current.contains(event.target)
      ) {
        setShowChassis2Dropdown(false);
      }
      if (
        modelDropdownRef.current &&
        !modelDropdownRef.current.contains(event.target)
      ) {
        setShowModelDropdown(false);
      }
      if (
        classificationDropdownRef.current &&
        !classificationDropdownRef.current.contains(event.target)
      ) {
        setShowClassificationDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        vinDropdownRef.current &&
        !vinDropdownRef.current.contains(event.target)
      ) {
        setShowVinDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   console.log("VIN Suggestions State Updated:", {
  //     vinSuggestions,
  //     showVinDropdown,
  //     isLoadingVinSuggestions,
  //     vinInput,
  //     vinSuggestionsLength: vinSuggestions.length,
  //   });
  // }, [vinSuggestions, showVinDropdown, isLoadingVinSuggestions, vinInput]);

  useEffect(() => {
    // Load language from localStorage on component mount
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'jp';
    setSelectedLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage);

    // Listen for language changes from other pages
    const handleStorageChange = (e) => {
      if (e.key === 'selectedLanguage' && e.newValue) {
        setSelectedLanguage(e.newValue);
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);

  // Update displayed data when language changes
  useEffect(() => {
    const processLanguageChange = async () => {

      const currentData = dataByLanguage[selectedLanguage];

      setGroups(currentData.groups);
      setVinResults(currentData.vinResults);
      setChassisResults(currentData.chassisResults);

      // Store original group values before updating them
      const originalGroup = selectedGroup;
      const originalGroupMainGroup = selectedGroupMainGroup;

      // Update main group values to the new language
      if (currentData.groups && currentData.groups.length > 0 && selectedGroup && selectedGroupMainGroup && selectedGroupIndex !== -1) {
        // Use the stored group index to map to the equivalent group in the new language
        if (currentData.groups[selectedGroupIndex]) {
          const newGroup = currentData.groups[selectedGroupIndex];
          setSelectedGroup(newGroup.group_name);
          setSelectedGroupMainGroup(newGroup.main_group);
        }
      }

      // Handle sub groups data and mapping using the NEW group values from current language data
      // Handle sub groups data and mapping using the NEW group values from current language data
      let availableSubGroups = [];
      const currentGroupName = selectedGroupIndex !== -1 && currentData.groups && currentData.groups[selectedGroupIndex]
        ? currentData.groups[selectedGroupIndex].group_name
        : selectedGroup;
      const currentMainGroup = selectedGroupIndex !== -1 && currentData.groups && currentData.groups[selectedGroupIndex]
        ? currentData.groups[selectedGroupIndex].main_group
        : selectedGroupMainGroup;

      // For model search, get sub groups from the stored subGroups array, filtered by selected group
      if (searchType === "model" && currentData.subGroups && currentData.subGroups.length > 0 && currentMainGroup) {

        // FIXED: Filter primarily by main_group numeric ID, which is stable across languages
        const filteredSubGroups = currentData.subGroups.filter(subGroup => {
          // Try exact match first
          if (subGroup.main_group === currentMainGroup) {
            return true;
          }
          // Try string comparison as fallback
          if (String(subGroup.main_group) === String(currentMainGroup)) {
            return true;
          }
          // If subgroup has a parent_main_group or similar field, check that too
          if (subGroup.parent_main_group === currentMainGroup || String(subGroup.parent_main_group) === String(currentMainGroup)) {
            return true;
          }
          return false;
        });

        availableSubGroups = filteredSubGroups;
      }
      // For VIN search, get sub groups from vinResults using the current language group values
      else if (searchType === "vin" && currentData.vinResults && currentData.vinResults.groups && currentGroupName && currentMainGroup) {
        const selectedGroupData = currentData.vinResults.groups.find(
          (group) => group.group_name === currentGroupName && group.main_group === currentMainGroup
        );
        availableSubGroups = selectedGroupData ? selectedGroupData.sub_groups || [] : [];
      }
      // For Chassis search, get sub groups from chassisResults using the current language group values
      else if (searchType === "chassis" && currentData.chassisResults && currentData.chassisResults.groups && currentGroupName && currentMainGroup) {
        const selectedGroupData = currentData.chassisResults.groups.find(
          (group) => group.group_name === currentGroupName && group.main_group === currentMainGroup
        );
        availableSubGroups = selectedGroupData ? selectedGroupData.sub_groups || [] : [];
      }

      // Update sub groups list and handle language mapping
      if (availableSubGroups.length > 0) {
        setSubGroups(availableSubGroups);

        // Update selected subgroup to the new language using stored index
        if (selectedSubGroupIndex !== -1 && availableSubGroups[selectedSubGroupIndex]) {
          const newSubGroup = availableSubGroups[selectedSubGroupIndex];
          setSelectedSubGroup(newSubGroup.sub_group);
          setSelectedSubGroupMainGroup(newSubGroup.group_name);
        } else if (selectedSubGroup && availableSubGroups.length > 0) {
          // Try to find the subgroup by matching the current selectedSubGroup name
          const matchingSubGroup = availableSubGroups.find(sg =>
            sg.sub_group === selectedSubGroup ||
            sg.group_name === selectedSubGroupMainGroup
          );
          if (matchingSubGroup) {
            const newIndex = availableSubGroups.indexOf(matchingSubGroup);
            setSelectedSubGroup(matchingSubGroup.sub_group);
            setSelectedSubGroupMainGroup(matchingSubGroup.group_name);
            setSelectedSubGroupIndex(newIndex);
          } else {
          }
        } else {
        }
      }
      else if (searchType === "model" && currentGroupName && currentMainGroup) {

        // Fetch for the current language only
        const fetchedData = await fetchSubGroups("", currentMainGroup, false);

        // After fetching, get the updated data and process subgroups
        if (fetchedData && fetchedData[selectedLanguage]) {
          const fetchedSubGroups = fetchedData[selectedLanguage].sub_groups || [];

          if (fetchedSubGroups.length > 0) {
            // Filter sub groups for the selected group
            const filteredSubGroups = fetchedSubGroups.filter(subGroup => {
              const matchByMainGroup = subGroup.main_group === currentMainGroup;
              const matchByMainGroupString = String(subGroup.main_group) === String(currentMainGroup);
              return matchByMainGroup || matchByMainGroupString;
            });

            if (filteredSubGroups.length > 0) {
              setSubGroups(filteredSubGroups);

              // Update selected subgroup using stored index
              if (selectedSubGroupIndex !== -1 && filteredSubGroups[selectedSubGroupIndex]) {
                const newSubGroup = filteredSubGroups[selectedSubGroupIndex];
                setSelectedSubGroup(newSubGroup.sub_group);
                setSelectedSubGroupMainGroup(newSubGroup.group_name);
              }
            }
          }
        }
      }
    };

    processLanguageChange();
  }, [selectedLanguage, dataByLanguage]);

  useEffect(() => {
    // Check if both group and subgroup are selected
    const hasValidSelection =
      selectedGroup &&
      selectedGroupMainGroup &&
      selectedSubGroup &&
      selectedSubGroupMainGroup;
    const hasTextInput = userInput.trim().length > 0;

    // Enable send button only if both conditions are met
    setIsSendButtonDisabled(!(hasValidSelection && hasTextInput));
  }, [
    selectedGroup,
    selectedGroupMainGroup,
    selectedSubGroup,
    selectedSubGroupMainGroup,
    userInput,
  ]);

  // Handle click outside the dropdown menu to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdownId(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        queriesDropdownRef.current &&
        !queriesDropdownRef.current.contains(event.target)
      ) {
        setIsQueriesDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Add click outside handler for language menu
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        languageMenuRef.current &&
        !languageMenuRef.current.contains(event.target)
      ) {
        setShowLanguageMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Function to check window size and set sidebar state
    const checkWindowSize = () => {
      const isLargeScreen = window.innerWidth >= 992;
      setIsSidebarOpen(isLargeScreen);
    };

    checkWindowSize();
    window.addEventListener("resize", checkWindowSize);
    return () => {
      window.removeEventListener("resize", checkWindowSize);
    };
  }, []);

  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();

      recognition.continuous = true;
      recognition.interimResults = true;

      // Find the speech code for the selected language
      const currentLanguage = languageOptions.find(
        (lang) => lang.code === selectedLanguage
      );
      recognition.lang = currentLanguage ? currentLanguage.speechCode : "en-US";

      recognition.onstart = () => {
        setIsListening(true);
      };

      recognition.onresult = (event) => {
        const current = event.resultIndex;
        const transcript = event.results[current][0].transcript;
        const fullTranscript = Array.from(event.results)
          .map((result) => result[0].transcript)
          .join(" ");

        setUserInput(fullTranscript);

        if (fullTranscript.trim().length > 0 && selectedSubGroup) {
          setIsSendButtonDisabled(false);
        }
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        if (event.error === "no-speech" && isListening) {
          try {
            setTimeout(() => {
              recognition.start();
            }, 100);
          } catch (e) {
            console.error("Failed to restart after no-speech error", e);
          }
        }
      };

      recognition.onend = () => {
        if (isListening) {
          try {
            recognition.start();
          } catch (e) {
            console.error("Failed to restart speech recognition", e);
            setIsListening(false);
          }
        } else {
          setIsListening(false);
        }
      };

      setSpeechRecognition(recognition);
    } else {
      console.warn("Speech recognition not supported in this browser");
    }
    return () => {
      if (speechRecognition) {
        speechRecognition.abort();
      }
    };
  }, [selectedLanguage]);

  const handleChassis1InputChange = (e) => {
    const value = e.target.value;
    setChassis1Input(value);

    // Reset selections and disable send button
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);

    // Reset chassis results
    setChassisResults(null);
    setGroups([]);
    setSubGroups([]);
    setChassisError("");

    // Clear existing timeouts
    if (vinTimeoutRef.current) {
      clearTimeout(vinTimeoutRef.current);
    }
    if (chassis1SuggestionsTimeoutRef.current) {
      clearTimeout(chassis1SuggestionsTimeoutRef.current);
    }

    // Fetch chassis1 suggestions with debounce
    if (value.length > 0) {
      chassis1SuggestionsTimeoutRef.current = setTimeout(() => {
        fetchChassis1Suggestions(value);
      }, 300);
    } else {
      setChassis1Suggestions([]);
      setShowChassis1Dropdown(false);
      setHasChassis1SuggestionsResponse(false);
    }

    if (value.trim() && chassis2Input.trim()) {
      // Check if both chassis numbers have reasonable length (e.g., at least 3 characters)
      const minLength = 3;
      if (value.trim().length >= minLength && chassis2Input.trim().length >= minLength) {
        vinTimeoutRef.current = setTimeout(() => {
          lookupByChassis(value.trim(), chassis2Input.trim());
        }, 800); // Increased debounce time to 800ms
      }
    }
  };

  const handleChassis2InputChange = (e) => {
    const value = e.target.value;
    setChassis2Input(value);

    // Reset selections and disable send button
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);

    // Reset chassis results
    setChassisResults(null);
    setGroups([]);
    setSubGroups([]);
    setChassisError("");

    // Validate chassis2 length (must be exactly 7 digits, excluding spaces)
    const valueWithoutSpaces = value.replace(/\s/g, '');
    if (valueWithoutSpaces.length > 0 && valueWithoutSpaces.length !== 7) {
      setChassis2LengthError(true);
    } else {
      setChassis2LengthError(false);
    }

    // Clear existing timeouts
    if (vinTimeoutRef.current) {
      clearTimeout(vinTimeoutRef.current);
    }
    if (chassis2SuggestionsTimeoutRef.current) {
      clearTimeout(chassis2SuggestionsTimeoutRef.current);
    }

    // Fetch chassis2 suggestions with debounce
    if (value.length > 0) {
      chassis2SuggestionsTimeoutRef.current = setTimeout(() => {
        fetchChassis2Suggestions(value);
      }, 300);
    } else {
      setChassis2Suggestions([]);
      setShowChassis2Dropdown(false);
      setHasChassis2SuggestionsResponse(false);
    }

    // If both chassis inputs have content, trigger lookup
    if (chassis1Input.trim() && value.trim()) {
      // Check if both chassis numbers have reasonable length (e.g., at least 3 characters)
      const minLength = 3;
      if (chassis1Input.trim().length >= minLength && value.trim().length >= minLength) {
        vinTimeoutRef.current = setTimeout(() => {
          lookupByChassis(chassis1Input.trim(), value.trim());
        }, 800); // Increased debounce time to 800ms
      }
    }
  };

  const handleChassis1SuggestionSelect = (suggestion) => {
    setChassis1Input(suggestion);
    setShowChassis1Dropdown(false);
    setChassis1Suggestions([]);

    // NEW: Reset the response flag to prevent validation error
    setHasChassis1SuggestionsResponse(false);

    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setChassisResults(null);
    setGroups([]);
    setSubGroups([]);
    setChassisError("");

    if (suggestion.trim() && chassis2Input.trim()) {
      lookupByChassis(suggestion, chassis2Input);
    }
  };

  const handleChassis2SuggestionSelect = (suggestion) => {
    setChassis2Input(suggestion);
    setShowChassis2Dropdown(false);
    setChassis2Suggestions([]);

    // NEW: Reset the response flag to prevent validation error
    setHasChassis2SuggestionsResponse(false);

    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setChassisResults(null);
    setGroups([]);
    setSubGroups([]);
    setChassisError("");
    setChassis2LengthError(false);

    if (chassis1Input.trim() && suggestion.trim()) {
      lookupByChassis(chassis1Input, suggestion);
    }
  };

  const handleHideChassis1Suggestions = () => {
    setShowChassis1Dropdown(false);
  };

  const handleHideChassis2Suggestions = () => {
    setShowChassis2Dropdown(false);
  };

  const handleModelSuggestionSelect = (suggestion) => {
    setModelInput(suggestion);
    setShowModelDropdown(false);
    setModelSuggestions([]);
    setHasModelSuggestionsResponse(false);
  };

  const handleClassificationSuggestionSelect = (suggestion) => {
    setClassificationInput(suggestion);
    setShowClassificationDropdown(false);
    setClassificationSuggestions([]);
    setHasClassificationSuggestionsResponse(false);
  };

  const handleHideModelSuggestions = () => {
    setShowModelDropdown(false);
  };

  const handleHideClassificationSuggestions = () => {
    setShowClassificationDropdown(false);
  };

  const lookupByChassis = async (chassis1, chassis2) => {
    setIsLoadingChassis(true);
    setGroups([]);
    setSubGroups([]);
    setChassisResults(null);
    setChassisError("");

    try {
      // Fetch data for both languages
      const fetchDataForLanguage = async (language) => {
        const payload = {};
        if (chassis1) payload.chassis_no_1 = chassis1;
        if (chassis2) payload.chassis_no_2 = chassis2;
        payload.language = language;

        const response = await fetch(`${CHAT_API_ENDPOINTS.GET_CATALOG}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`Failed to lookup chassis for ${language}`);
        }

        return await response.json();
      };

      // Fetch data for both English and Japanese
      const [enData, jpData] = await Promise.all([
        fetchDataForLanguage('en'),
        fetchDataForLanguage('jp')
      ]);

      // Store data for both languages
      setDataByLanguage(prev => ({
        ...prev,
        en: {
          ...prev.en,
          groups: enData.groups || [],
          subGroups: enData.sub_groups || [],
          chassisResults: enData
        },
        jp: {
          ...prev.jp,
          groups: jpData.groups || [],
          subGroups: jpData.sub_groups || [],
          chassisResults: jpData
        }
      }));

      // Set current language data for immediate display
      const currentData = selectedLanguage === 'en' ? enData : jpData;
      setChassisResults(currentData);

      if (currentData && currentData.zone) {
        const zoneString = String(currentData.zone);
        setZone(zoneString);
      } else {
        setZone("");
      }

      if (currentData && currentData.groups && currentData.groups.length > 0) {
        setGroups(currentData.groups);
        setChassisError("");
      } else {
        setGroups([]);
        setChassisError("No data found for the provided chassis numbers");
      }

      if (currentData) {
        setSearchInput((prev) => ({
          ...prev,
          adjusted_line_off_date: currentData.adjusted_line_off_date || "",
          catalog_no: currentData.catalog_no || "",
          model: currentData.model_code || "",
          classification: currentData.model_classification || "",
          chassis_no_1: chassis1,
          chassis_no_2: chassis2,
          zone: String(currentData.zone || ""),
          opt: currentData.opt || "",
        }));

        setAdjustedLineOffDate(currentData.adjusted_line_off_date || "");
        setCatalogNo(currentData.catalog_no || "");
        setModel(currentData.model_code || "");
        setClassification(currentData.model_classification || "");
        setOpt(currentData.opt || "");
      }
    } catch (error) {
      console.error("Error looking up chassis:", error);
      setChassisResults(null);
      setGroups([]);
      setChassisError("Error looking up chassis numbers");
    } finally {
      setIsLoadingChassis(false);
    }
  };

  const toggleSpeechRecognition = () => {
    if (!speechRecognition) {
      console.warn("Speech recognition not supported");
      return;
    }

    if (isListening) {
      setIsListening(false);
      speechRecognition.stop();
    } else {
      // Update language before starting
      const currentLanguage = languageOptions.find(
        (lang) => lang.code === selectedLanguage
      );
      speechRecognition.lang = currentLanguage
        ? currentLanguage.speechCode
        : "en-US";

      setUserInput("");
      setIsListening(true);
      try {
        speechRecognition.start();
      } catch (e) {
        console.error("Failed to start speech recognition", e);
      }
    }
  };

  const handleLanguageChange = (langCode) => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }
    setSelectedLanguage(langCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem('selectedLanguage', langCode); // Save to localStorage
    setShowLanguageMenu(false);
  };

  const toggleSidebar = () => {
    document.querySelector(".sidebarPnc").classList.add("animating");
    const toggleButton = document.querySelector(
      ".historyIconPnc img.cursor-pointer"
    );
    if (toggleButton) {
      toggleButton.classList.toggle("toggle-open");
      toggleButton.classList.toggle("toggle-closed");
    }
    setIsSidebarOpen(!isSidebarOpen);
    setTimeout(() => {
      const sidebar = document.querySelector(".sidebarPnc");
      if (sidebar) sidebar.classList.remove("animating");
    }, 500);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        logoutDropdownRef.current &&
        !logoutDropdownRef.current.contains(event.target)
      ) {
        setIsLogoutDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectPastQuery = (queryText) => {
    setIsQueriesDropdownOpen(false);
    const messageElements = document.querySelectorAll(".userPartPnc");

    let found = false;
    messageElements.forEach((element) => {
      const questionElement = element.querySelector(".questionPartPnc");
      if (
        questionElement &&
        questionElement.textContent.trim() === queryText.trim()
      ) {
        scrollToElement(element);
        found = true;
      }
    });

    if (!found) {
      messageElements.forEach((element) => {
        const questionElement = element.querySelector(".questionPartPnc");
        if (
          questionElement &&
          questionElement.textContent.includes(queryText.trim())
        ) {
          scrollToElement(element);
          found = true;
        }
      });
    }

    if (!found) {
      const userMessages = messages.filter(
        (msg) =>
          msg.sender === "user" && !msg.isUserFeedback && !msg.isYesOption
      );
      const targetIndex = userMessages.findIndex(
        (msg) => msg.text === queryText
      );

      if (targetIndex !== -1) {
        let userMessageCount = 0;

        for (let i = 0; i < messageElements.length; i++) {
          if (messageElements[i].querySelector(".questionPartPnc")) {
            if (userMessageCount === targetIndex) {
              scrollToElement(messageElements[i]);
              found = true;
              break;
            }
            userMessageCount++;
          }
        }
      }
    }
    if (!found) {
      // console.log("Could not find message with text:", queryText);
    }
  };

  const scrollToElement = (element) => {
    element.scrollIntoView({ behavior: "smooth", block: "center" });
    element.classList.add("highlight-message");
    setTimeout(() => {
      element.classList.remove("highlight-message");
    }, 2000);
  };

  const toggleFeedbackModal = () => {
    setIsFeedbackModalOpen(!isFeedbackModalOpen);
  };

  const toggleDropdown = (id, e) => {
    e.stopPropagation();
    setActiveDropdownId((prevId) => (prevId === id ? null : id));
  };

  // Function to handle feedback submission
  const handleFeedbackSubmit = (feedbackData) => {
    alert("Thank you for your feedback!");
  };

  const handleStartChat = () => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }
    setUserInput("");

    setIsChatStarted(true);
    setChatId(null);
    setSelectedHistoryId(null);

    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);

    setShowSearchParams(true);

    // Create a search parameters entry to insert into the messages array
    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: searchType,
      showSearchParams: true,
    };
    setMessages([searchParamsEntry]);

    setUserMessages([]);
    setAssistantMessages([]);
    setShowPromptSuggestion(false);
  };

  const toggleAboutModal = () => {
    setIsAboutModalOpen(!isAboutModalOpen);
  };

  const scrollToBottom = () => {
    try {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    } catch (error) {
      console.error("Error scrolling to bottom:", error);
    }
  };

  useEffect(() => {
    scrollToBottom();
    const timeoutId = setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, 100);

    const secondTimeoutId = setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    }, 500);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(secondTimeoutId);
    };
  }, [messages, isThinking, assistantMessages, userMessages]);

  useEffect(() => {
    if (!chatContainerRef.current) return;
    const observer = new MutationObserver(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }
    });
    observer.observe(chatContainerRef.current, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // console.log("Updated Messages:", messages);
  }, [messages]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setDots((prev) => (prev.length < 3 ? prev + "." : ""));
  //   }, 500);

  //   return () => clearInterval(interval);
  // }, []);
  const saveCurrentConversation = () => {
    setConversationHistory((prev) => ({
      ...prev,
      [conversationCycleId]: {
        userMessages: [...userMessages],
        assistantMessages: [...assistantMessages],
        searchType,
        searchInput: { ...searchInput },
        selectedGroup,
        selectedGroupMainGroup,
        selectedSubGroup,
        selectedSubGroupMainGroup,
        chatId,
      },
    }));
  };

  useEffect(() => {
    // console.log("chatId state updated:", chatId);
  }, [chatId]);

  useEffect(() => {
    if (userMessages.length > 0 || assistantMessages.length > 0) {
      saveCurrentConversation();
    }
  }, [userMessages, assistantMessages, conversationCycleId]);

  const handleFeedback = (index, response) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }

        // Hide YesSelection buttons
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
          };
        }

        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
          };
        }

        return msg;
      })
    );

    const updatedMessage = {
      ...assistantMessages[index],
      feedbackSubmitted: true,
      userFeedback: response,
      hideFeedbackButtons: true,
    };

    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.messageId === updatedMessage.messageId ? updatedMessage : msg
      )
    );

    setAssistantMessages((prevAssistantMessages) =>
      prevAssistantMessages.map((msg, i) =>
        i === index ? updatedMessage : msg
      )
    );

    const feedbackMessage = {
      text: response, // "Yes" or "No"
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-feedback-${Date.now()}`,
      sender: "user",
      isUserFeedback: true,
      referenceMessageId: assistantMessages[index]?.messageId,
      userFeedback: response,
    };

    setMessages((prevMessages) => {
      const newMessages = [...prevMessages, feedbackMessage];
      return newMessages;
    });

    // If the response is "Yes", show the YesSelection component
    if (response === "Yes") {
      const yesSelectionMessage = {
        timestamp: new Date(),
        cycleId: conversationCycleId,
        messageId: `${conversationCycleId}-yes-selection-${Date.now()}`,
        showYesSelection: true,
        optionSelected: false,
      };

      setMessages((prevMessages) => [...prevMessages, yesSelectionMessage]);
    }
    // If user says "No", insert FusoChatEndMessage into the array
    else if (response === "No") {
      const endMessage = {
        text: "Awesome! If you ever need more info, just start a new chat. Have a great day!",
        timestamp: new Date(),
        cycleId: conversationCycleId,
        messageId: `${conversationCycleId}-end-message-${Date.now()}`,
        sender: "assistant",
        isFollowUp: true,
        showAskAnotherQueryButton: true,
      };

      // Add the end message to the messages array
      setMessages((prevMessages) => [...prevMessages, endMessage]);
    }

    saveCurrentConversation();
  };

  const handleResetQueryWithPreservedInputs = () => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }

    setUserInput("");
    setIsSendButtonDisabled(true);

    // Hide existing messages
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return { ...msg, hideFeedbackButtons: true };
        }
        if (msg.showYesSelection) {
          return { ...msg, hideButtons: true, optionSelected: true };
        }
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
            hideAskAnotherQueryButton: true,
          };
        }
        if (msg.type === "promptSuggestion" && msg.showPromptSuggestion) {
          return { ...msg, showPromptSuggestion: false, dismissed: true };
        }
        return msg;
      })
    );

    saveCurrentConversation();
    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);

    // PRESERVE current search inputs and selections
    const preservedSearchType = searchType;
    const preservedVinInput = vinInput;
    const preservedModelInput = modelInput;
    const preservedClassificationInput = classificationInput;
    const preservedVinResults = vinResults;
    const preservedGroups = groups;
    const preservedIsValidVin = isValidVin;
    const preservedIsValidModelClass = isValidModelClass;

    // NEW: Preserve group and subgroup selections
    const preservedSelectedGroup = selectedGroup;
    const preservedSelectedGroupMainGroup = selectedGroupMainGroup;
    const preservedSelectedSubGroup = selectedSubGroup;
    const preservedSelectedSubGroupMainGroup = selectedSubGroupMainGroup;

    // Reset only group/subgroup selections
    // setSelectedGroup("");
    // setSelectedGroupMainGroup("");
    // setSelectedSubGroup("");
    // setSelectedSubGroupMainGroup("");
    // setGroupDropdownOpen(false);
    // setSubGroupDropdownOpen(false);

    // Keep other validation states
    setVinError("");
    setModelClassError("");
    setIsLoadingVin(false);
    setIsLoadingModelClass(false);
    setIsLoadingSubGroups(false);

    // Create search parameters entry with preserved inputs
    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: preservedSearchType,
      showSearchParams: true,
      isChangeSelection: true, // NEW FLAG
      preserveInputs: true, // NEW FLAG
      preservedData: {
        // NEW DATA
        vinInput: preservedVinInput,
        modelInput: preservedModelInput,
        classificationInput: preservedClassificationInput,
        vinResults: preservedVinResults,
        groups: preservedGroups,
        isValidVin: preservedIsValidVin,
        isValidModelClass: preservedIsValidModelClass,
        // NEW: Add group/subgroup preservation
        selectedGroup: preservedSelectedGroup,
        selectedGroupMainGroup: preservedSelectedGroupMainGroup,
        selectedSubGroup: preservedSelectedSubGroup,
        selectedSubGroupMainGroup: preservedSelectedSubGroupMainGroup,
      },
    };

    setMessages((prevMessages) => [...prevMessages, searchParamsEntry]);
    setShowSearchParams(true);
    setHideInitialMessages(true);
    setAskAnotherQueryClicked(true);
    setShowYesSelection(false);
    setShowPromptSuggestion(false);

    setTimeout(scrollToBottom, 100);
  };

  const handleYesSelectionOption = (option) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.showYesSelection) {
          return {
            ...msg,
            optionSelected: true,
            hideButtons: true,
          };
        }
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }
        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
          };
        }
        return msg;
      })
    );
    const optionMessage = {
      textKey: option === "rephrase" ? "rephraseQues" : "changeSelection",
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-yes-option-${Date.now()}`,
      sender: "user",
      isYesOption: true,
    };

    setMessages((prevMessages) => [...prevMessages, optionMessage]);

    if (option === "rephrase") {
      setIsSendButtonDisabled(false);
      const assistantResponseMessage = {
        textKey: "gotItMessage",
        timestamp: new Date(),
        cycleId: conversationCycleId,
        messageId: `${conversationCycleId}-assistant-rephrase-${Date.now()}`,
        sender: "assistant",
        isRephraseResponse: true,
        showRephraseQuestion: true,
      };
      setMessages((prevMessages) => [
        ...prevMessages,
        assistantResponseMessage,
      ]);

      setUserInput("");
    } else if (option === "change") {
      const assistantMessage = {
        textKey: "noWorriesMessage",
        timestamp: new Date(),
        cycleId: conversationCycleId,
        messageId: `${conversationCycleId}-assistant-change-${Date.now()}`,
        sender: "assistant",
        isChangeSelectionResponse: true,
      };
      setMessages((prevMessages) => [...prevMessages, assistantMessage]);
      setTimeout(() => {
        // handleResetQuery();
        handleResetQueryWithPreservedInputs();
      }, 800);
    }
  };

  const addInitialSystemMessage = () => {
    const initialMessage = {
      textKey: "allSetMessage",
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-assistant-initial-${Date.now()}`,
      sender: "assistant",
      isInitialMessage: true,
    };
    const initialMessageExists = messages.some(
      (msg) => msg.isInitialMessage && msg.cycleId === conversationCycleId
    );
    if (!initialMessageExists) {
      setMessages((prevMessages) => [...prevMessages, initialMessage]);
      setTimeout(scrollToBottom, 100);
    }
  };
  const groupDropdownRef = useRef(null);
  const subGroupDropdownRef = useRef(null);

  const lookupVin = async (vin) => {
    setIsLoadingVin(true);

    setGroups([]);
    setSubGroups([]);
    setVinResults(null);
    setIsValidVin(false);
    setVinError("");

    // Trim whitespace from the VIN
    const trimmedVin = vin.trim();

    try {
      // Fetch data for both languages
      const fetchDataForLanguage = async (language) => {
        const response = await fetch(`${CHAT_API_ENDPOINTS.GET_CATALOG}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vin: trimmedVin, language: language }),
        });

        if (!response.ok) {
          throw new Error(`Failed to lookup VIN for ${language}`);
        }

        return await response.json();
      };

      // Fetch data for both English and Japanese
      const [enData, jpData] = await Promise.all([
        fetchDataForLanguage('en'),
        fetchDataForLanguage('jp')
      ]);

      // Store data for both languages
      setDataByLanguage(prev => ({
        ...prev,
        en: {
          ...prev.en,
          groups: enData.groups || [],
          subGroups: enData.sub_groups || [],
          vinResults: enData
        },
        jp: {
          ...prev.jp,
          groups: jpData.groups || [],
          subGroups: jpData.sub_groups || [],
          vinResults: jpData
        }
      }));

      // Set current language data for immediate display
      const currentData = selectedLanguage === 'en' ? enData : jpData;
      setVinResults(currentData);

      if (currentData && currentData.zone) {
        const zoneString = String(currentData.zone);
        setZone(zoneString);
      } else {
        setZone("");
      }

      if (currentData && currentData.groups && currentData.groups.length > 0) {
        setGroups(currentData.groups);
        setIsValidVin(true);
        setVinError("");
      } else {
        setIsValidVin(false);
        setVinError(t("enterValidVIN"));
        setGroups([]);
      }

      if (currentData) {
        setSearchInput((prev) => ({
          ...prev,
          adjusted_line_off_date: currentData.adjusted_line_off_date || "",
          catalog_no: currentData.catalog_no || "",
          model: currentData.model_code || "",
          classification: currentData.model_classification || "",
          vin: trimmedVin,
          zone: String(currentData.zone || ""),
          opt: currentData.opt || "",
        }));

        setAdjustedLineOffDate(currentData.adjusted_line_off_date || "");
        setCatalogNo(currentData.catalog_no || "");
        setModel(currentData.model_code || "");
        setClassification(currentData.model_classification || "");
        setOpt(currentData.opt || "");
      }
    } catch (error) {
      console.error("Error looking up VIN:", error);
      setVinResults(null);
      setGroups([]);
      setIsValidVin(false);
      setVinError(t("enterValidVIN"));
    } finally {
      setIsLoadingVin(false);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        vinDropdownRef.current &&
        !vinDropdownRef.current.contains(event.target)
      ) {
        setShowVinDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (modelInput.trim() && classificationInput.trim()) {
      if (debounceTimer) clearTimeout(debounceTimer);
      const timer = setTimeout(() => {
        lookupByModelAndClassification(modelInput, classificationInput);
      }, 400);
      setDebounceTimer(timer);
    }
    return () => clearTimeout(debounceTimer);
  }, [modelInput, classificationInput]);

  const lookupByModelAndClassification = async (model, classification) => {
  const trimmedModel = model.trim();
  const trimmedClassification = classification.trim();
  setModelClassError("");
  setIsValidModelClass(false);
  setIsLoadingModelClass(true);

  try {
    const fetchDataForLanguage = async (language) => {
      const response = await fetch(`${CHAT_API_ENDPOINTS.GET_CATALOG}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          model: trimmedModel,
          classification: trimmedClassification,
          language: language,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to lookup by model and classification for ${language}`);
      }

      return await response.json();
    };

    const [enData, jpData] = await Promise.all([
      fetchDataForLanguage('en'),
      fetchDataForLanguage('jp')
    ]);

    // ADDED: Flatten subgroups from groups array
    const flattenSubGroups = (data) => {
      if (!data.groups || !Array.isArray(data.groups)) return [];
      
      const allSubGroups = [];
      data.groups.forEach(group => {
        if (group.sub_groups && Array.isArray(group.sub_groups)) {
          // Add the main_group to each subgroup for filtering later
          group.sub_groups.forEach(subGroup => {
            allSubGroups.push({
              ...subGroup,
              main_group: group.main_group,
              parent_group_name: group.group_name
            });
          });
        }
      });
      return allSubGroups;
    };

    setDataByLanguage(prev => ({
      ...prev,
      en: {
        ...prev.en,
        groups: enData.groups || [],
        subGroups: flattenSubGroups(enData), // CHANGED: Flatten subgroups
        modelClassResults: enData
      },
      jp: {
        ...prev.jp,
        groups: jpData.groups || [],
        subGroups: flattenSubGroups(jpData), // CHANGED: Flatten subgroups
        modelClassResults: jpData
      }
    }));

    const currentData = selectedLanguage === 'en' ? enData : jpData;
    setVinResults(currentData);

    if (currentData && currentData.zone) {
      const zoneString = String(currentData.zone);
      setZone(zoneString);
    } else {
      setZone("");
    }

    if (currentData && currentData.error) {
      setIsValidModelClass(false);
      setModelClassError(currentData.error || t("errorFindingData"));
      setGroups([]);
    } else if (currentData && currentData.groups && currentData.groups.length > 0) {
      setGroups(currentData.groups);
      setIsValidModelClass(true);
      setModelClassError("");
    } else {
      setIsValidModelClass(false);
      setModelClassError("");
      setGroups([]);
    }

    if (currentData) {
      setAdjustedLineOffDate(currentData.adjusted_line_off_date || "");
      setCatalogNo(currentData.catalog_no || "");
      setModel(currentData.model_code || "");
      setClassification(currentData.model_classification || "");
      setOpt(currentData.opt || "");

      setSearchInput((prev) => ({
        ...prev,
        adjusted_line_off_date: currentData.adjusted_line_off_date || "",
        catalog_no: currentData.catalog_no || "",
        model: currentData.model_code || trimmedModel,
        classification: currentData.model_classification || trimmedClassification,
        zone: currentData.zone || "",
        opt: currentData.opt || "",
      }));
    }
  } catch (error) {
    console.error("Error looking up by model and classification:", error);
    setVinResults(null);
    setGroups([]);
    setIsValidModelClass(false);
    setModelClassError(t("errorFindingData"));
  } finally {
    setIsLoadingModelClass(false);
  }
};

  const fetchSubGroups = async (vin, mainGroup, fetchBothLanguages = true, forceFetch = false) => {
     if (!forceFetch) {
    if (
      (searchType === "vin" && vinResults && vinResults.groups) ||
      (searchType === "model" && groups && groups.length > 0)
    ) {
      // Check if we actually need to fetch
      if (searchType === "model") {
        const hasEnSubGroups = dataByLanguage.en.subGroups && dataByLanguage.en.subGroups.length > 0;
        const hasJpSubGroups = dataByLanguage.jp.subGroups && dataByLanguage.jp.subGroups.length > 0;
        
        // Only return early if we have subgroups for both languages
        if (hasEnSubGroups && hasJpSubGroups) {
          return;
        }
      } else {
        return;
      }
    }
  }
    if (
      (searchType === "vin" && vinResults && vinResults.groups) ||
      (searchType === "model" && groups && groups.length > 0)
    ) {
      return;
    }

    try {
      setIsLoadingSubGroups(true);
      const payload = {
        main_group: mainGroup,
      };
      if (vin) {
        payload.vin = vin;
      }

      if (model) payload.model = model;
      if (classification) payload.classification = classification;
      if (catalogNo) payload.catalog_no = catalogNo;
      if (adjustedLineOffDate)
        payload.adjusted_line_off_date = adjustedLineOffDate;

      if (fetchBothLanguages) {
        // Fetch sub groups for both languages
        const fetchSubGroupsForLanguage = async (language) => {
          const response = await fetch(`${CHAT_API_ENDPOINTS.GET_SUB_GROUP}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...payload,
              zone: String(zone || ""),
              language: language,
            }),
          });

          if (!response.ok) {
            throw new Error(`Failed to fetch sub groups for ${language}`);
          }

          return await response.json();
        };

        // Fetch data for both English and Japanese
        const [enData, jpData] = await Promise.all([
          fetchSubGroupsForLanguage('en'),
          fetchSubGroupsForLanguage('jp')
        ]);

        // Store sub groups data for both languages
        setDataByLanguage(prev => ({
          ...prev,
          en: {
            ...prev.en,
            subGroups: enData.sub_groups || []
          },
          jp: {
            ...prev.jp,
            subGroups: jpData.sub_groups || []
          }
        }));

        // Set current language sub groups for immediate display
        const currentData = selectedLanguage === 'en' ? enData : jpData;
        setSubGroups(currentData.sub_groups || []);

        if (currentData && currentData.zone) {
          setZone(currentData.zone);
        } else {
          setZone("");
        }

        // ADDED: Return the fetched data so the caller can use it
        return { enData, jpData };
      } else {
        // Fetch sub groups for current language only
        const response = await fetch(`${CHAT_API_ENDPOINTS.GET_SUB_GROUP}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...payload,
            zone: String(zone || ""),
            language: selectedLanguage,
          }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch sub groups for ${selectedLanguage}`);
        }

        const data = await response.json();
        setSubGroups(data.sub_groups || []);

        // Also update dataByLanguage for the current language to ensure consistency
        setDataByLanguage(prev => ({
          ...prev,
          [selectedLanguage]: {
            ...prev[selectedLanguage],
            subGroups: data.sub_groups || []
          }
        }));

        if (data && data.zone) {
          setZone(data.zone);
        } else {
          setZone("");
        }

        // ADDED: Return the fetched data
        return { [selectedLanguage]: data };
      }
    } catch (error) {
      console.error("Error fetching sub-groups:", error);
      return null;
    } finally {
      setIsLoadingSubGroups(false);
    }
  };

  const sendFinalQuery = async (query) => {
    try {
      const payload = {
        main_group: selectedGroupMainGroup,
        sub_group: selectedSubGroup,
        adjusted_line_off_date: searchInput.adjusted_line_off_date,
        zone: zone,
        user_id:
          sessionStorage.getItem("user_id") ||
          localStorage.getItem("user_id") ||
          "",
        user_query: query,
        chat_id: chatId,
        language: selectedLanguage,
        opt: searchInput.opt || opt || "",
      };

      // Add search-type specific data
      if (searchType === "vin") {
        payload.vin = searchInput.vin;
        payload.model = searchInput.model;
        payload.classification = searchInput.classification;
        payload.catalog_no = searchInput.catalog_no;
      } else if (searchType === "chassis") {
        payload.chassis_no_1 = chassis1Input;
        payload.chassis_no_2 = chassis2Input;
        if (searchInput.model) payload.model = searchInput.model;
        if (searchInput.classification)
          payload.classification = searchInput.classification;
        if (searchInput.catalog_no) payload.catalog_no = searchInput.catalog_no;
      } else if (searchType === "model") {
        payload.model = searchInput.model || modelInput;
        payload.classification =
          searchInput.classification || classificationInput;
        if (searchInput.catalog_no) payload.catalog_no = searchInput.catalog_no;
      }

      const response = await fetch(`${CHAT_API_ENDPOINTS.FINAL_QUERY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data && data.chat_id) {
        setChatId(data.chat_id);
      }
      return data;
    } catch (error) {
      console.error("Error sending final query:", error);
      return null;
    }
  };

  const handleModelInputChange = (e) => {
    const value = e.target.value;
    setModelInput(value);
    setIsValidModelClass(false);
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setIsLoadingModelClass(false);
    setModelClassError("");

    // Clear existing timeout
    if (modelSuggestionsTimeoutRef.current) {
      clearTimeout(modelSuggestionsTimeoutRef.current);
    }

    // Fetch model suggestions with debounce
    if (value.length > 0) {
      modelSuggestionsTimeoutRef.current = setTimeout(() => {
        fetchModelSuggestions(value);
      }, 300);
    } else {
      setModelSuggestions([]);
      setShowModelDropdown(false);
      setHasModelSuggestionsResponse(false);
    }
  };

  const handleClassificationInputChange = (e) => {
    const value = e.target.value;
    setClassificationInput(value);
    setIsValidModelClass(false);
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setIsLoadingModelClass(false);
    setModelClassError("");

    // Clear existing timeout
    if (classificationSuggestionsTimeoutRef.current) {
      clearTimeout(classificationSuggestionsTimeoutRef.current);
    }

    // Fetch classification suggestions with debounce
    if (value.length > 0) {
      classificationSuggestionsTimeoutRef.current = setTimeout(() => {
        fetchClassificationSuggestions(value);
      }, 300);
    } else {
      setClassificationSuggestions([]);
      setShowClassificationDropdown(false);
      setHasClassificationSuggestionsResponse(false);
    }
  };

  const handleVinInputChange = (e) => {
    const value = e.target.value;
    setVinInput(value);

    // Reset ALL VIN-related states immediately
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setVinResults(null);
    setGroups([]);
    setSubGroups([]);
    setIsValidVin(false);
    setVinError("");

    // Clear suggestion states
    setVinSuggestions([]);
    setShowVinDropdown(false);
    setHasVinSuggestionsResponse(false);

    // Clear existing timeouts
    if (vinTimeoutRef.current) {
      clearTimeout(vinTimeoutRef.current);
    }
    if (vinSuggestionsTimeoutRef.current) {
      clearTimeout(vinSuggestionsTimeoutRef.current);
    }

    if (value.length > 0) {
      vinSuggestionsTimeoutRef.current = setTimeout(() => {
        fetchVinSuggestions(value);
      }, 300);
    }

    // Original VIN lookup logic (for 13+ characters)
    if (value.length >= 13) {
      vinTimeoutRef.current = setTimeout(() => {
        lookupVin(value);
      }, 400);
    }
  };

  const handleVinSuggestionSelect = (suggestion) => {
    setVinInput(suggestion);
    setShowVinDropdown(false);
    setVinSuggestions([]);
    setHasVinSuggestionsResponse(false);

    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setVinResults(null);
    setGroups([]);
    setSubGroups([]);
    setIsValidVin(false);
    setVinError("");

    if (suggestion.length >= 13) {
      lookupVin(suggestion);
    }
  };

  const handleHideVinSuggestions = () => {
    setShowVinDropdown(false);
  };

  const handleGroupSelect = async (selectedOption, index = -1) => {
    const [groupName, mainGroup] = selectedOption.split("|");
    setSelectedGroup(groupName);
    setSelectedGroupMainGroup(mainGroup);
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);

    // Store the group index for language mapping
    setSelectedGroupIndex(index);

    if (searchType === "model") {
      // Check if we have subgroups stored for BOTH languages
      const hasEnSubGroups = dataByLanguage.en.subGroups && dataByLanguage.en.subGroups.length > 0;
      const hasJpSubGroups = dataByLanguage.jp.subGroups && dataByLanguage.jp.subGroups.length > 0;

      // If either language is missing subgroups, fetch for both languages
      if (!hasEnSubGroups || !hasJpSubGroups) {
        await fetchSubGroups("", mainGroup, true, true);

        // Wait for state update
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Now filter subgroups for the selected group
      const currentData = dataByLanguage[selectedLanguage];
      if (currentData.subGroups && currentData.subGroups.length > 0) {
        const filteredSubGroups = currentData.subGroups.filter(subGroup => {
          const matchByMainGroup = subGroup.main_group === mainGroup;
          const matchByMainGroupString = String(subGroup.main_group) === String(mainGroup);
          return matchByMainGroup || matchByMainGroupString;
        });
        setSubGroups(filteredSubGroups);
      }
    }
  };

  const handleSubGroupSelect = (selectedOption, index = -1) => {
    const [selectedSubGroupName, selectedSubGroupGroup] =
      selectedOption.split("|");

    setSelectedSubGroup(selectedSubGroupName);
    setSelectedSubGroupMainGroup(selectedSubGroupGroup);

    // Store the index for language mapping
    setSelectedSubGroupIndex(index);

    if (
      selectedGroup &&
      selectedGroupMainGroup &&
      selectedSubGroupName &&
      selectedSubGroupGroup
    ) {
      setIsSendButtonDisabled(false);
    } else {
      setIsSendButtonDisabled(true);
    }

    const randomIndex = Math.floor(Math.random() * promptSuggestions.length);
    setSelectedPromptIndex(randomIndex);

    addInitialSystemMessage();
    setShowPromptSuggestion(true);
    setMessages((prevMessages) =>
      prevMessages.filter((msg) => !(msg.type === "promptSuggestion"))
    );

    setTimeout(scrollToBottom, 100);
  };

  const handlePromptSuggestionSelect = (suggestion, messageId) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
            optionSelected: true,
          };
        }

        // Hide Ask Another Query button
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
          };
        }

        // Hide other prompt suggestions
        if (
          msg.type === "promptSuggestion" &&
          msg.showPromptSuggestion &&
          msg.messageId !== messageId
        ) {
          return {
            ...msg,
            showPromptSuggestion: false,
            dismissed: true,
          };
        }

        return msg;
      })
    );
    setUserInput(suggestion);
    setIsSendButtonDisabled(false);
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.messageId === messageId
          ? { ...msg, selected: true, showPromptSuggestion: false }
          : msg
      )
    );

    // Hide the prompt suggestion footer
    setShowPromptSuggestion(false);
    const inputField = document.querySelector(
      'textarea[placeholder="Ask anything..."]'
    );
    if (inputField) {
      inputField.focus();
    }
    setTimeout(scrollToBottom, 100);
  };
  const dismissPromptSuggestion = (messageId) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.messageId === messageId
          ? { ...msg, dismissed: true, showPromptSuggestion: false }
          : msg
      )
    );
    setShowPromptSuggestion(false);
  };

  const isSearchValid =
    (searchType === "vin" && isValidVin) ||
    (searchType === "model" && isValidModelClass);

  const handleUserInputChange = (e) => {
    setUserInput(e.target.value);

    // Enable send button only if we have text input AND both group and subgroup selected
    const hasValidSelection =
      selectedGroup &&
      selectedGroupMainGroup &&
      selectedSubGroup &&
      selectedSubGroupMainGroup;
    const hasTextInput = e.target.value.trim().length > 0;

    setIsSendButtonDisabled(!(hasValidSelection && hasTextInput));
  };

  const handleSendMessage = async () => {
    // Check for empty input and show validation message
    if (userInput.trim() === "") {
      const inputField =
        document.querySelector("textarea") ||
        document.querySelector('input[type="text"]');
      if (inputField) {
        inputField.classList.add("error-input");
        const existingError = document.querySelector(".input-error-message");
        if (!existingError) {
          const errorMessage = document.createElement("div");
          errorMessage.className = "input-error-message";
          // errorMessage.textContent = "Please type a message";
          errorMessage.textContent = t("pleaseTypeMessage");
          errorMessage.innerHTML = t("pleaseTypeMessage");
          inputField.parentNode.parentNode.appendChild(errorMessage);
          setTimeout(() => {
            inputField.classList.remove("error-input");
            errorMessage.remove();
          }, 3000);
        }
      }
      return;
    }

    if (!selectedSubGroup || isSendButtonDisabled) return;
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }

    setShowYesSelection(false);
    setHideInitialMessages(true);
    setShowSearchParams(false);
    setShowPromptSuggestion(false);
    setTimeout(scrollToBottom, 100);
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.type === "promptSuggestion" && msg.showPromptSuggestion
          ? { ...msg, showPromptSuggestion: false, dismissed: true }
          : msg
      )
    );

    // Create user message object
    const newUserMessage = {
      text: userInput,
      timestamp: new Date(),
      cycleId: conversationCycleId,
      messageId: `${conversationCycleId}-user-${Date.now()}`,
      sender: "user",
      searchInfo: {
        vin: searchType === "vin" ? vinInput : "",
        model: searchInput.model || modelInput,
        classification: searchInput.classification || classificationInput,
        chassis1: searchType === "chassis" ? chassis1Input : "",
        chassis2: searchType === "chassis" ? chassis2Input : "",
        mainGroup: selectedGroupMainGroup,
        subGroup: selectedSubGroup,
      },
    };

    setMessages((prevMessages) => {
      const updatedMessages = prevMessages.map((msg) => {
        // Hide Yes/No feedback buttons
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }

        // Hide YesSelection buttons
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
          };
        }
        // Hide Ask Another Query button - added multiple flags to ensure it's hidden
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
            hideAskAnotherQueryButton: true,
          };
        }

        // Hide prompts
        if (msg.type === "promptSuggestion") {
          return {
            ...msg,
            showPromptSuggestion: false,
            dismissed: true,
          };
        }

        return msg;
      });

      // Remove search parameters and other UI elements that should be hidden
      const filteredMessages = updatedMessages.filter(
        (msg) => !(msg.type === "searchParameters" || msg.isInitialMessage)
      );

      return [...filteredMessages, newUserMessage];
    });

    setUserMessages((prevUserMessages) => [
      ...prevUserMessages,
      newUserMessage,
    ]);
    setShowUserPart(true);
    setAskAnotherQueryClicked(false);

    setUserInput("");

    setIsThinking(true);

    try {
      // Make API call in a way that doesn't affect the sidebar state
      const response = await sendFinalQuery(newUserMessage.text);

      setIsThinking(false);

      if (response) {
        const newAssistantMessage = {
          text: response.response || "I don't have related information",
          timestamp: new Date(),
          cycleId: conversationCycleId,
          messageId: `${conversationCycleId}-assistant-${Date.now()}`,
          sender: "assistant",
          chatId: response.chat_id,
          chat_record_id: response.chat_record_id,
          user_feedback: response.user_feedback,
          spn_url: response.spn_url,
          imageLinks: response.image_link
            ? response.image_link.map((img) => `data:image/jpeg;base64,${img}`)
            : [],
        };
        setMessages((prevMessages) => [...prevMessages, newAssistantMessage]);
        if (response.chat_id) {
          setChatId(response.chat_id);
        }
      }
    } catch (error) {
      console.error("Error sending query:", error);
      setIsThinking(false);
    } finally {
      setTimeout(() => {
        fetchChatHistory();
      }, 300);
    }

    scrollToBottom();
  };

  // Handle key press for sending message with Enter key
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleResetQuery = () => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }
    setUserInput("");
    setIsSendButtonDisabled(true);
    setMessages((prevMessages) =>
      prevMessages.map((msg) => {
        // Hide any Yes/No feedback buttons
        if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
          return {
            ...msg,
            hideFeedbackButtons: true,
          };
        }

        // Hide YesSelection buttons
        if (msg.showYesSelection) {
          return {
            ...msg,
            hideButtons: true,
            optionSelected: true,
          };
        }

        // Hide Ask Another Query button - using multiple flags for redundancy
        if (msg.isFollowUp) {
          return {
            ...msg,
            showAskAnotherQueryButton: false,
            hideAskAnotherQueryButton: true,
          };
        }

        // Hide prompt suggestions
        if (msg.type === "promptSuggestion" && msg.showPromptSuggestion) {
          return {
            ...msg,
            showPromptSuggestion: false,
            dismissed: true,
          };
        }

        return msg;
      })
    );

    saveCurrentConversation();
    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);
    resetSearchState();
    setIsSendButtonDisabled(true);
    const searchParamsEntry = {
      type: "searchParameters",
      timestamp: new Date(),
      cycleId: newCycleId,
      messageId: `${newCycleId}-search-params-${Date.now()}`,
      searchType: "",
      showSearchParams: true,
    };
    setMessages((prevMessages) => [...prevMessages, searchParamsEntry]);

    setShowSearchParams(true);
    setHideInitialMessages(true);
    setAskAnotherQueryClicked(true);
    setShowYesSelection(false);
    setUserInput("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setGroupDropdownOpen(false);
    setSubGroupDropdownOpen(false);
    setVinError("");
    setModelClassError("");
    setIsLoadingVin(false);
    setIsLoadingModelClass(false);
    setIsLoadingSubGroups(false);
    setTimeout(scrollToBottom, 100);
    setShowPromptSuggestion(false);
  };

  const resetSearchState = () => {
    setSearchInput({
      vin: "",
      model: "",
      classification: "",
    });
    setVinError("");
    setModelClassError("");
    setIsValidVin(false);
    setIsValidModelClass(false);
    setGroups([]);
    setSubGroups([]);
    setVinInput("");
    setModelInput("");
    setClassificationInput("");
    setSelectedSubGroup("");
    setSelectedSubGroupMainGroup("");
    setSelectedGroup("");
    setSelectedGroupMainGroup("");
    setSelectedGroupIndex(-1);
    setSelectedSubGroupIndex(-1);
    setIsSendButtonDisabled(true);
    setChassisError("");
    setChassis1Input("");
    setChassis2Input("");
    setChassisResults(null);
    setChassis1Suggestions([]);
    setChassis2Suggestions([]);
    setShowChassis1Dropdown(false);
    setShowChassis2Dropdown(false);
    setHasChassis1SuggestionsResponse(false);
    setHasChassis2SuggestionsResponse(false);
  };

  const resetToWelcomePage = () => {
    if (isListening && speechRecognition) {
      speechRecognition.stop();
      setIsListening(false);
    }

    // Clear the textarea
    setUserInput("");
    setIsChatStarted(false);
    setChatId(null);
    setSelectedHistoryId(null);
    setIsSendButtonDisabled(true);
    setShowQueriesInChat(false);
    setUserMessages([]);
    setAssistantMessages([]);
    setMessages([]);
    resetSearchState();
    setShowSearchParams(false);
    setHideInitialMessages(false);
    setAskAnotherQueryClicked(false);
    setShowYesSelection(false);
    const newCycleId = `cycle-${Date.now()}`;
    setConversationCycleId(newCycleId);
    setShowPromptSuggestion(false);
  };

  //Chat History Section
  const userId =
    sessionStorage.getItem("user_id") ||
    localStorage.getItem("user_id") ||
    userId ||
    "";

  const getUTCDateParts = (date) => {
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth(),
      day: date.getUTCDate(),
    };
  };

  // Compare two dates for same day (ignoring time)
  const isSameUTCDay = (date1, date2) => {
    const d1 = getUTCDateParts(date1);
    const d2 = getUTCDateParts(date2);

    return d1.year === d2.year && d1.month === d2.month && d1.day === d2.day;
  };
  // Replace the existing fetchChatHistory function in PncNew.js with this version:

  const fetchChatHistory = async () => {
    const sidebarElement = document.querySelector(".sidebarPnc");
    if (sidebarElement) {
      sidebarElement.classList.add("loading");
    }
    const historyContainer = document.querySelector(".historyTabPnc");
    const scrollPosition = historyContainer ? historyContainer.scrollTop : 0;

    try {
      setIsLoadingHistory(false);

      const response = await fetch(
        `${CHAT_API_ENDPOINTS.GET_CHAT_HISTORY_LIST}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // user_id: userId,
            user_id:
              sessionStorage.getItem("user_id") ||
              localStorage.getItem("user_id") ||
              userId ||
              "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch chat history");
      }

      const data = await response.json();

      // Check for the specific error response structure
      if (
        data &&
        data.status === false &&
        data.message === "data for this user id not found"
      ) {
        // Set empty arrays to represent no history
        setPinnedChats([]);
        setChatHistory([]);
      } else if (data) {
        const historyArray = Object.values(data);
        const historyWithTimestamps = historyArray.map((item) => {
          const date = new Date(item.time_stamp);
          return {
            ...item,
            timestamp: date,
            dateString: date.toLocaleString(),
          };
        });

        // Sort history in descending order (newest first)
        historyWithTimestamps.sort((a, b) => {
          const timeA = b.timestamp.getTime();
          const timeB = a.timestamp.getTime();

          if (timeA !== timeB) {
            return timeA - timeB;
          }
          // Secondary sort by ID to ensure consistent ordering
          const idA = a.chat_id || a.title_id || "";
          const idB = b.chat_id || b.title_id || "";
          return idB.localeCompare(idA);
        });
        // Find pinned chats based on the pinned: 1 flag
        const pinnedItems = historyWithTimestamps.filter(
          (item) => item.pinned === 1
        );

        // Also sort pinned items by time (newest first)
        pinnedItems.sort((a, b) => b.timestamp - a.timestamp);

        // Update states with minimal UI disruption
        setPinnedChats(pinnedItems);
        setChatHistory(historyWithTimestamps);
      } else {
        setPinnedChats([]);
        setChatHistory([]);
      }

      // Restore scroll position after state updates
      setTimeout(() => {
        if (historyContainer) {
          historyContainer.scrollTop = scrollPosition;
        }
      }, 50);
    } catch (error) {
      console.error("Error fetching chat history:", error);
      // Instead of setting an error message, set empty arrays
      setPinnedChats([]);
      setChatHistory([]);
      // setHistoryError("Failed to load chat history");
    } finally {
      setIsLoadingHistory(false);
      if (sidebarElement) {
        setTimeout(() => {
          sidebarElement.classList.remove("loading");
        });
      }
    }
  };

  const togglePinStatus = async (historyItem, e) => {
    e.stopPropagation();
    const chatId = historyItem.chat_id || historyItem.title_id;

    if (!chatId) {
      console.error("Missing chat_id in history item");
      return;
    }
    const isPinned = historyItem.pinned === 1;
    const newPinStatus = isPinned ? 0 : 1;

    // Store current state for potential rollback
    const currentPinnedChats = [...pinnedChats];
    const currentChatHistory = [...chatHistory];

    try {
      if (newPinStatus === 1) {
        const updatedItem = { ...historyItem, pinned: 1 };
        setPinnedChats((prev) => [...prev, updatedItem]);
        setChatHistory((prev) =>
          prev.map((item) =>
            (item.chat_id || item.title_id) === chatId
              ? { ...item, pinned: 1 }
              : item
          )
        );
      } else {
        setPinnedChats((prev) =>
          prev.filter((item) => (item.chat_id || item.title_id) !== chatId)
        );
        setChatHistory((prev) =>
          prev.map((item) =>
            (item.chat_id || item.title_id) === chatId
              ? { ...item, pinned: 0 }
              : item
          )
        );
      }

      // Close the dropdown
      setActiveDropdownId(null);

      // Now make the API call
      const response = await fetch(CHAT_API_ENDPOINTS.PIN_CHAT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          user_id:
            sessionStorage.getItem("user_id") ||
            localStorage.getItem("user_id") ||
            userId ||
            "",
          pinned: newPinStatus,
        }),
      });
      if (!response.ok) {
        const errorText = await response.text();
        console.error("API error response:", errorText);
        throw new Error(`API returned ${response.status}: ${errorText}`);
      }
      const data = await response.json();
    } catch (error) {
      console.error("Error in togglePinStatus:", error.message);

      setPinnedChats(currentPinnedChats);
      setChatHistory(currentChatHistory);

      alert(`Failed to ${isPinned ? "unpin" : "pin"} chat. Please try again.`);
    }
  };

  // These two handler functions use the same togglePinStatus function
  const handlePinChat = (historyItem, e) => {
    togglePinStatus(historyItem, e);
  };

  // Fixed delete button click handler
  const handleDeleteButtonClick = (item, e) => {
    e.preventDefault();
    e.stopPropagation();

    setDeleteItemInfo(item);
    setIsDeleteModalOpen(true);
    setActiveDropdownId(null);
  };

  const handleConfirmDelete = () => {
    if (!deleteItemInfo) return;

    const chatId = deleteItemInfo.chat_id || deleteItemInfo.title_id;
    if (!chatId) {
      console.error("Missing chat_id in history item");
      setIsDeleteModalOpen(false);
      return;
    }

    deleteChat(deleteItemInfo, chatId);
    setIsDeleteModalOpen(false);
  };

  // Delete chat API function
  const deleteChat = async (item, chatId) => {
    try {
      // Make API call to delete chat
      const response = await fetch(
        `${CHAT_API_ENDPOINTS.DELETE_CHAT_HISTORY}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatId,
            user_id:
              sessionStorage.getItem("user_id") ||
              localStorage.getItem("user_id") ||
              userId ||
              "",
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Delete API error:", errorText);
        throw new Error(`Failed to delete chat: ${response.status}`);
      }

      const data = await response.json();

      // Update both states: pinnedChats and chatHistory
      setPinnedChats((prevChats) =>
        prevChats.filter((chat) => (chat.chat_id || chat.title_id) !== chatId)
      );

      setChatHistory((prevHistory) =>
        prevHistory.filter((chat) => (chat.chat_id || chat.title_id) !== chatId)
      );

      setActiveDropdownId(null);

      if (selectedHistoryId === chatId) {
        resetToWelcomePage();
      }

      // Show success toast
      setToastMessage(t("chatDeletedSuccess"));
      setShowToast(true);

      // Hide toast after 3 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 3000);
    } catch (error) {
      console.error("Error deleting chat:", error);
      alert("Failed to delete chat. Please try again.");
    }
  };

  // Fixed unpin button click handler
  const handleUnpinButtonClick = (item, e) => {
    e.preventDefault();
    e.stopPropagation();
    const chatId = item.chat_id || item.title_id;

    if (!chatId) {
      console.error("Missing chat_id in history item");
      return;
    }
    // Call the unpin API
    unpinChat(item, chatId);
  };

  // Unpin chat API function
  const unpinChat = async (item, chatId) => {
    try {
      setPinnedChats((prevChats) =>
        prevChats.filter((chat) => (chat.chat_id || chat.title_id) !== chatId)
      );

      setChatHistory((prevHistory) =>
        prevHistory.map((chat) =>
          (chat.chat_id || chat.title_id) === chatId
            ? { ...chat, pinned: 0 }
            : chat
        )
      );
      setActiveDropdownId(null);

      // Make API call to unpin chat
      const response = await fetch(`${CHAT_API_ENDPOINTS.PIN_CHAT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          user_id: userId,
          pinned: 0,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Unpin API error:", errorText);
        throw new Error(`Failed to unpin chat: ${response.status}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error unpinning chat:", error);
      alert("Failed to unpin chat. Please try again.");
      fetchChatHistory();
    }
  };

  useEffect(() => {
    fetchChatHistory();
  }, []);

  useEffect(() => {
    if (chatHistory.length > 0) {
      setChatHistory((prevHistory) => {
        const sortedHistory = [...prevHistory];
        sortedHistory.sort((a, b) => b.timestamp - a.timestamp);
        return sortedHistory;
      });

      setPinnedChats((prevPinned) => {
        const sortedPinned = [...prevPinned];
        sortedPinned.sort((a, b) => b.timestamp - a.timestamp);
        return sortedPinned;
      });
    }
  }, []);

  // Modified handleHistoryItemClick function to sort messages chronologically
  const handleHistoryItemClick = async (historyItem) => {
    if (!historyItem) {
      console.error("Invalid history item");
      return;
    }

    const chatId = historyItem.chat_id || historyItem.title_id;

    if (!chatId) {
      console.error("Missing chat_id/title_id in history item");
      return;
    }

    try {
      setSelectedHistoryId(chatId);
      setShowQueriesInChat(true);
      setShowPromptSuggestion(false);
      setUserInput("");
      // Reset group selections when switching history items
      setSelectedGroup("");
      setSelectedGroupMainGroup("");
      setSelectedSubGroup("");
      setSelectedSubGroupMainGroup("");
      setSelectedGroupIndex(-1);
      setSelectedSubGroupIndex(-1);
      setMessages((prevMessages) =>
        prevMessages.map((msg) => {
          if (msg.sender === "assistant" && !msg.hideFeedbackButtons) {
            return {
              ...msg,
              hideFeedbackButtons: true,
            };
          }

          // Hide YesSelection buttons
          if (msg.showYesSelection) {
            return {
              ...msg,
              hideButtons: true,
              optionSelected: true,
            };
          }

          // Hide Ask Another Query button
          if (msg.isFollowUp) {
            return {
              ...msg,
              showAskAnotherQueryButton: false,
            };
          }

          // Hide prompt suggestions
          if (msg.type === "promptSuggestion" && msg.showPromptSuggestion) {
            return {
              ...msg,
              showPromptSuggestion: false,
              dismissed: true,
            };
          }

          return msg;
        })
      );

      const response = await fetch(
        CHAT_API_ENDPOINTS.GET_CHAT_HISTORY_DETAILS,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            chat_id: chatId,
            user_id:
              sessionStorage.getItem("user_id") ||
              localStorage.getItem("user_id") ||
              userId ||
              "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch conversation details");
      }

      const conversationData = await response.json();
      // console.log("Raw conversation data:", conversationData);

      setIsChatStarted(true);
      const historyCycleId = `history-${Date.now()}`;
      setConversationCycleId(historyCycleId);
      setChatId(chatId);
      setMessages([]);

      let processedMessages = [];

      if (conversationData && typeof conversationData === "object") {
        const items = Object.values(conversationData);

        // Sort items by timestamp (oldest first)
        items.sort((a, b) => {
          const timeA = new Date(a.time_stamp || 0).getTime();
          const timeB = new Date(b.time_stamp || 0).getTime();
          return timeA - timeB;
        });

        items.forEach((item, index) => {
          // First add user message if it exists
          if (item.user_question) {
            processedMessages.push({
              text: item.user_question,
              timestamp: new Date(item.time_stamp || Date.now()),
              cycleId: historyCycleId,
              messageId: `${historyCycleId}-user-${index}`,
              sender: "user",
            });
          }

          // Then add assistant message if it exists
          if (item.ai_response) {
            processedMessages.push({
              text: item.ai_response,
              timestamp: new Date(item.time_stamp || Date.now()),
              cycleId: historyCycleId,
              messageId: `${historyCycleId}-assistant-${index}`,
              sender: "assistant",
              chatId: chatId,
              chat_record_id: item.chat_record_id,
              user_feedback: item.user_feedback,
              spn_url: item.spn_url,
              isHistoryView: true,
              hideFeedbackButtons: true,
              imageLinks: Array.isArray(item.images)
                ? item.images.map((img) => `data:image/jpeg;base64,${img}`)
                : [],
            });
          }
        });

        // Add a final end message with the "Ask another query" button
        processedMessages.push({
          text: "Awesome! If you ever need more info, just start a new chat. Have a great day!",
          timestamp: new Date(),
          cycleId: historyCycleId,
          messageId: `${historyCycleId}-end-message-${Date.now()}`,
          sender: "assistant",
          isFollowUp: true,
          showAskAnotherQueryButton: true,
        });
      }

      if (processedMessages.length > 0) {
        setShowSearchParams(false);
        setHideInitialMessages(true);
        setShowUserPart(true);
        setIsSendButtonDisabled(true);
        setMessages(processedMessages);
        setAskAnotherQueryClicked(false);
      } else {
        console.warn("No messages found in history response");
        alert("No conversation history found. Starting a new chat.");
        handleStartChat();
      }
    } catch (error) {
      console.error("Error loading conversation from history:", error);
      alert("Failed to load conversation history. Please try again.");
    }
  };

  return (
    <div>
      <div
        className={`bg-gray-50 min-h-screen flex relative overflow-hidden pncMainPart ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
      >
        {/* Sidebar */}
        <div className="leftSideBarPnc">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            resetToWelcomePage={resetToWelcomePage}
            toggleFeedbackModal={toggleFeedbackModal}
            chatHistory={chatHistory}
            pinnedChats={pinnedChats}
            selectedHistoryId={selectedHistoryId}
            handleHistoryItemClick={handleHistoryItemClick}
            isLoadingHistory={isLoadingHistory}
            historyError={historyError}
            toggleDropdown={toggleDropdown}
            activeDropdownId={activeDropdownId}
            handleDeleteButtonClick={handleDeleteButtonClick}
            handlePinChat={handlePinChat}
            handleUnpinButtonClick={handleUnpinButtonClick}
            toggleAboutModal={toggleAboutModal}
            handleLogout={handleLogout}
          />
        </div>
        {/* Main Content */}
        <div className="flex-1 flex flex-col h-screen bg-[#FFFFFF]">
          <Header
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={toggleSidebar}
            resetToWelcomePage={resetToWelcomePage}
            toggleAboutModal={toggleAboutModal}
            showQueriesInChat={showQueriesInChat}
            isQueriesDropdownOpen={isQueriesDropdownOpen}
            setIsQueriesDropdownOpen={setIsQueriesDropdownOpen}
            handleSelectPastQuery={handleSelectPastQuery}
            isLogoutDropdownOpen={isLogoutDropdownOpen}
            setIsLogoutDropdownOpen={setIsLogoutDropdownOpen}
            handleLogout={handleLogout}
            messages={messages}
            selectedLanguage={selectedLanguage}
            showLanguageMenu={showLanguageMenu}
            setShowLanguageMenu={setShowLanguageMenu}
            languageOptions={languageOptions}
            handleLanguageChange={handleLanguageChange}
          />
          <Main
            // Chat state
            isChatStarted={isChatStarted}
            handleStartChat={handleStartChat}
            messages={messages}
            isThinking={isThinking}
            dots={dots}
            conversationCycleId={conversationCycleId}
            // Search parameters
            showSearchParams={showSearchParams}
            searchType={searchType}
            setSearchType={setSearchType}
            isSearchValid={isSearchValid}
            // VIN input
            vinInput={vinInput}
            handleVinInputChange={handleVinInputChange}
            isLoadingVin={isLoadingVin}
            vinError={vinError}
            // Model & Classification input
            modelInput={modelInput}
            classificationInput={classificationInput}
            handleModelInputChange={handleModelInputChange}
            handleClassificationInputChange={handleClassificationInputChange}
            isLoadingModelClass={isLoadingModelClass}
            modelClassError={modelClassError}
            // Groups & Subgroups
            groups={groups}
            subGroups={subGroups}
            selectedGroup={selectedGroup}
            selectedGroupMainGroup={selectedGroupMainGroup}
            selectedSubGroup={selectedSubGroup}
            selectedSubGroupMainGroup={selectedSubGroupMainGroup}
            groupDropdownOpen={groupDropdownOpen}
            subGroupDropdownOpen={subGroupDropdownOpen}
            setGroupDropdownOpen={setGroupDropdownOpen}
            setSubGroupDropdownOpen={setSubGroupDropdownOpen}
            handleGroupSelect={handleGroupSelect}
            handleSubGroupSelect={handleSubGroupSelect}
            isLoadingSubGroups={isLoadingSubGroups}
            resetSearchState={resetSearchState}
            // Message interaction handlers
            handleYesSelectionOption={handleYesSelectionOption}
            handleFeedback={handleFeedback}
            handleResetQuery={handleResetQuery}
            askAnotherQueryClicked={askAnotherQueryClicked}
            // User input
            userInput={userInput}
            handleUserInputChange={handleUserInputChange}
            handleKeyPress={handleKeyPress}
            isSendButtonDisabled={isSendButtonDisabled}
            handleSendMessage={handleSendMessage}
            // Voice input
            isListening={isListening}
            toggleSpeechRecognition={toggleSpeechRecognition}
            // Prompt suggestions
            showPromptSuggestion={showPromptSuggestion}
            selectedPromptIndex={selectedPromptIndex}
            promptSuggestions={promptSuggestions}
            handlePromptSuggestionSelect={handlePromptSuggestionSelect}
            dismissPromptSuggestion={dismissPromptSuggestion}
            speechRecognition={speechRecognition}
            vinResults={vinResults}
            vinSuggestions={vinSuggestions}
            showVinDropdown={showVinDropdown}
            isLoadingVinSuggestions={isLoadingVinSuggestions}
            handleVinSuggestionSelect={handleVinSuggestionSelect}
            vinDropdownRef={vinDropdownRef}
            hasVinSuggestionsResponse={hasVinSuggestionsResponse}
            chassis1Input={chassis1Input}
            chassis2Input={chassis2Input}
            handleChassis1InputChange={handleChassis1InputChange}
            handleChassis2InputChange={handleChassis2InputChange}
            isLoadingChassis={isLoadingChassis}
            chassisError={chassisError}
            chassis2LengthError={chassis2LengthError}
            chassisResults={chassisResults}
            chassis1Suggestions={chassis1Suggestions}
            chassis2Suggestions={chassis2Suggestions}
            isLoadingChassis1Suggestions={isLoadingChassis1Suggestions}
            isLoadingChassis2Suggestions={isLoadingChassis2Suggestions}
            showChassis1Dropdown={showChassis1Dropdown}
            showChassis2Dropdown={showChassis2Dropdown}
            handleChassis1SuggestionSelect={handleChassis1SuggestionSelect}
            handleChassis2SuggestionSelect={handleChassis2SuggestionSelect}
            handleHideChassis1Suggestions={handleHideChassis1Suggestions}
            handleHideChassis2Suggestions={handleHideChassis2Suggestions}
            chassis1DropdownRef={chassis1DropdownRef}
            chassis2DropdownRef={chassis2DropdownRef}
            hasChassis1SuggestionsResponse={hasChassis1SuggestionsResponse}
            hasChassis2SuggestionsResponse={hasChassis2SuggestionsResponse}
            handleHideVinSuggestions={handleHideVinSuggestions}
            modelSuggestions={modelSuggestions}
            classificationSuggestions={classificationSuggestions}
            isLoadingModelSuggestions={isLoadingModelSuggestions}
            isLoadingClassificationSuggestions={isLoadingClassificationSuggestions}
            showModelDropdown={showModelDropdown}
            showClassificationDropdown={showClassificationDropdown}
            handleModelSuggestionSelect={handleModelSuggestionSelect}
            handleClassificationSuggestionSelect={handleClassificationSuggestionSelect}
            handleHideModelSuggestions={handleHideModelSuggestions}
            handleHideClassificationSuggestions={handleHideClassificationSuggestions}
            modelDropdownRef={modelDropdownRef}
            classificationDropdownRef={classificationDropdownRef}
            hasModelSuggestionsResponse={hasModelSuggestionsResponse}
            hasClassificationSuggestionsResponse={hasClassificationSuggestionsResponse}
          />
        </div>
      </div>

      {showToast && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50 flex items-center feedsubmitPnc">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          {toastMessage}
        </div>
      )}
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
        chatTitle={deleteItemInfo?.title || "this conversation"}
      />
      <AboutModal
        isOpen={isAboutModalOpen}
        onClose={() => setIsAboutModalOpen(false)}
      />
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
    </div>
  );
};

export default PncNew;
